import React from "react";
import { Container, Navbar } from "react-bootstrap";
import Logo from "../../images/logo.png";
import "./style.css";

function Navbar22() {
  return (
    <Navbar>
      <Container>
        <Navbar.Brand href="#home">
          <img class="img-fluid" src={Logo} alt="" />
        </Navbar.Brand>
        <Navbar.Toggle />
        <Navbar.Collapse className="justify-content-end">
          <Navbar.Text>
            <button className="btncolor">Get the App</button>
          </Navbar.Text>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default Navbar22;
